export const MODAL_ON = "MODAL_ON"
export const MODAL_OFF = "MODAL_OFF"